export default {
  get genre() {
    if (!this.genres || !this.genres.length) {
      return undefined;
    }

    return this.genres.map((g) => g.name).join(', ');
  },
};
